import React from 'react';
import M2TLogo from './M2TLogo';

export default function FinalFooter() {
  return (
    <footer className="bg-black text-gray-400 border-t border-gray-700 py-6">
      <div className="w-full max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4">

        {/* Uncomment this block if you want to show logo + brand */}
        {/*
        <div className="flex items-center space-x-2">
          <M2TLogo className="w-16 h-16" />
          <span className="text-white font-semibold text-2xl">Million2Trillion</span>
        </div>
        */}

        {/* Center: Copyright */}
        <div className="text-sm text-center flex-1">
          © 2025 <strong className="text-white">Million2Trillion [M2T]</strong> — Your one-stop verified operating system to learn, earn, connect, and lead the global market.
        </div>

        {/* Uncomment this block to show footer links */}
        {/*
        <div className="flex flex-wrap justify-center md:justify-end gap-4 text-sm">
          <a href="#" className="hover:text-purple-400 transition">FAQ</a>
          <a href="#" className="hover:text-purple-400 transition">Marketplace</a>
          <a href="#" className="hover:text-purple-400 transition">Investor Page</a>
          <a href="#" className="hover:text-purple-400 transition">Policies</a>
          <a href="#" className="hover:text-purple-400 transition">Contact</a>
        </div>
        */}
      </div>
    </footer>
  );
}
